import * as React from 'react';
import {
    TabbedForm,
    FormTab,
    useTranslate,
    TextInput, BooleanInput, ReferenceInput, AutocompleteInput,
    useLocale,
} from 'react-admin';
import {Box, Typography} from "@material-ui/core";
import PostEditDeleteActions from "../../_common/PostEditDeleteActions";
//import {validateSumaRec} from "../utils/validateTable";
import {FileInputComp, ImageInputComp} from "../../_common/CompReact";

import {MyTranslatableInputs} from "../../_common/MyTranslatableInputs";
import {MyTranslatableInputsRich} from "../../_common/MyTranslatableInputsRich";
import {localesConfig} from "../../utils/config";
import {validateReq} from "../../_constants/validateTable";
import FootherEdit from "../../_common/Headers/FootherEdit";
import RelatedTradeMarks from "./RelatedTradeMarks";

//import { JsonSchemaForm } from "@react-admin/ra-json-schema-form";


const BlockEdit = props => {

    const {file} = props;
    const translate = useTranslate();
    const locale = useLocale();
    // const formEdit = useForm();

    return (
        <Box p="1em" fullWidth>

            <Box display="flex" alignItems={"top"}>
                <Box flex={4} mr={'2em'}>
                    <MyTranslatableInputs
                        validate={validateReq}
                        // prompt={promptData.find(x => x.field === 'name')}
                        fullWidth
                        source={'name'}
                        label={translate('Page Title')}
                    />
                </Box>
                <Box flex={1}>
                    <BooleanInput source="archive" label={translate('Archive')} defaultValue={false}/>
                </Box>
            </Box>

            <Box display="flex" alignItems={"top"} mb={'16px'}>
                <Box
                    style={{border: '1px solid #ddd', borderRadius: 16}}
                    display="flex"
                    alignItems={"top"}
                    flex={5} mr={"1em"}
                >
                    <ImageInputComp
                        maxSize={500000}
                        heightImg={180}
                        source={'image'}
                        // label={`${'New'} ${'image'}`}
                        label={''}
                        accept="image/*"
                        //validate={required()}
                        defaultValue={''}
                        placeholder={<p>Drop your <b>Image</b> here (500kb max)</p>}
                    />
                </Box>
                <Box alignItems={"top"} flex={7}>
                    <Box flex={1}>
                        <ReferenceInput
                            validate={validateReq}
                            label={translate('Categories')}
                            source={'catalog'}
                            reference={'dProductsGroup'}
                            //filter={{question$id: id}}
                        >
                            <AutocompleteInput optionText={`${'name'}[${locale}]`} resettable
                                               variant={"outlined"} fullWidth/>
                        </ReferenceInput>
                    </Box>
                    <Box flex={1}>
                        <MyTranslatableInputs
                            validate={validateReq}
                            // prompt={promptData.find(x => x.field === 'name')}
                            fullWidth
                            source={'country'}
                            label={translate('Country')}
                        />
                    </Box>
                    <Box flex={1}>
                        <MyTranslatableInputs
                            validate={validateReq}
                            // prompt={promptData.find(x => x.field === 'name')}
                            fullWidth
                            source={'url_repr'}
                            label={translate('Link to page')}
                        />
                    </Box>
                    <Box flex={1}>
                        <TextInput
                            validate={validateReq}
                            variant={"outlined"}
                            source={'url_site'}
                            label={translate('Manufacturer\'s website')}
                            fullWidth
                        />
                    </Box>
                    <Box flex={1}>
                        <TextInput
                            variant={"outlined"}
                            source={'manufacturer_catalog'}
                            label={translate('Link to manufacturer\'s catalog')}
                            fullWidth
                        />
                    </Box>
                    <Box flex={1}>
                        <TextInput
                            variant={"outlined"}
                            source={'priority'}
                            label={translate('Priority')}
                            fullWidth
                        />
                    </Box>
                    <Box flex={1}>
                        <ReferenceInput
                            label={translate('Brand')}
                            source={'brand'}
                            reference={'dBrands'}
                            //filter={{question$id: id}}
                        >
                            <AutocompleteInput optionText={`${'name'}[${locale}]`} resettable
                                               variant={"outlined"} fullWidth/>
                        </ReferenceInput>
                    </Box>
                </Box>
            </Box>

            <Box display="flex" alignItems={"top"}>
                <h5>{translate('Cross code file(csv or xls)')}: {file}</h5>
            </Box>
            {/*<FileInputComp
                source="file"
                label="PDF файл"
                accept="application/pdf"
                maxSize={5 * 1024 * 1024} // 5MB
                placeholder={<p>Выберите файл (max 5Mb)</p>}
            />*/}


            <Box display="flex" alignItems={"top"} mt={'-4em'}>
                <Box flex={4}>
                    <MyTranslatableInputsRich
                        // prompt={promptData.find(x => x.field === 'HTML')}
                        fullWidth
                        source={'HTML'}
                        label={translate('HTML')}
                    />
                </Box>
            </Box>


        </Box>
    )
}
export const TradeMarksEditCreate = props => {//Не работает
    /*const configureQuill = quill => quill.getModule('toolbar').addHandler('image', function (value) {
        this.quill.format('image', value)
    });*/
    const translate = useTranslate();
    const {record} = props;
    const {id, file} = record || {};

    const validateForm = (values) => {
        const errors = {};
        // console.log('VALID====>', values.description)
        if (values.country && !values.country[localesConfig.defaultLocale])
            errors.country = "Поле обязательно!";
        if (values.name && !values.name[localesConfig.defaultLocale])
            errors.name = "Поле обязательно!";
        if (values.url_repr && !values.url_repr[localesConfig.defaultLocale])
            errors.url_repr = "Поле обязательно!";

        return errors;
    };
    return (
        <Box>

            <TabbedForm
                {...props}
                validate={validateForm}
                toolbar={<PostEditDeleteActions goBack={false}/>}
                //redirect={redirect_url}
            >
                <FormTab label={translate('Common')}>
                    <BlockEdit
                        {...props}
                        id={id}
                        file={file}
                    />
                </FormTab>
                {/*<FormTab label={translate('Description')}>
                    <MyTranslatableInputsRich
                        source={'description'}
                        label={'Description'}
                        fullWidth
                    />
                </FormTab>*/}
            </TabbedForm>

            <Box p="1em" fullWidth>
                {id &&
                    <>
                        <Typography variant="h6">{translate('Categories')}</Typography>
                        <Box display="flex" alignItems={"center"}>
                            <RelatedTradeMarks
                                {...props}
                                relaited_id={id}
                                record={record}
                                isSave={false}
                            />
                        </Box>
                    </>
                }
            </Box>

            {id && <FootherEdit source={record.source}/>}
            {/*{id &&
                <Box display="flex" alignItems={"center"} p="1em">
                    <Box display="flex" flex={1} mr="2em" alignItems={"center"}>
                        <Box flex={1} style={{display: "flex"}} mr={'2em'}>
                            <Typography variant="subtitle2"
                                        gutterBottom>{translate('Source')}: <b>{record.source}</b></Typography>
                        </Box>
                    </Box>
                    <Box flex={1} align={'end'}>
                        <Box display="grid">
                            <div>Updated: <DateFieldComp source="updated" variant="subtitle2" fullWidth/></div>
                        </Box>
                    </Box>
                </Box>
            }
            */}
        </Box>
    )
};

export default TradeMarksEditCreate
